import { abortUpload } from 'serviceWorker/api/httpQueue';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { httpQueueContract } from 'shared/domain/httpQueue/httpQueueContract';

/** Answers HTTP queue requests of the page. */
export function serveHttpQueueRequests(): ChannelUnsubscribe {
  return channelServer.handle(httpQueueContract, { abortUpload });
}
